import React from 'react';
import block from 'bem-cn-lite';
import {Text} from '@gravity-ui/uikit';
import {House, Globe} from '@gravity-ui/icons';

import './SourceInfo.scss';

const b = block('source-info');

interface SourceInfoProps {
    source: string;
    className?: string;
}

export const SourceInfo: React.FC<SourceInfoProps> = ({source, className}) => {
    return (
        <div className={`${b('block', className)}`}>
            {source === 'лп' ? <House /> : <Globe />}
            <Text variant="body-1" className={b('text')}>
                {source}
            </Text>
        </div>
    );
};
